import { useSelector } from 'react-redux';
import SpotifyWebApi from 'spotify-web-api-node';
import { useDispatch } from 'react-redux';
import { setNewRelease } from 'actions/action';
import AppInstance from 'utils/instance';

const useNewRelease = () => {
  const dispatch = useDispatch();
  const webApi = new SpotifyWebApi();

  const token = AppInstance.getAccessToken();

  webApi.setAccessToken(token.access_token);

  const getNewRelease = async () => {
    dispatch(
      setNewRelease({
        isLoading: true,
        isError: false,
        data: null,
      })
    );
    try {
      const data = await webApi.getNewReleases({ limit: 10 });
      dispatch(
        setNewRelease({
          isLoading: false,
          isError: false,
          data: data.body,
        })
      );
    } catch (error) {
      AppInstance.removeAccessToken();
      dispatch(
        setNewRelease({
          isLoading: false,
          isError: true,
          data: null,
        })
      );
    }
  };

  return { getNewRelease };
};

export default useNewRelease;
